import * as source from "./source";

export function getNotificationsChild(id, type, page, rowPerPage) {
  return function (dispactch) {
    dispactch({
      type: "GET_NOTIFICATIONS_CHILD",
      payload: source.getNotifications(id, type, page, rowPerPage),
    });
  };
}
export function getNotificationsLady(id, type, page, rowPerPage) {
  return function (dispactch) {
    dispactch({
      type: "GET_NOTIFICATIONS_LADY",
      payload: source.getNotifications(id, type, page, rowPerPage),
    });
  };
}
export function getNotificationsPopOver(id, type, page, rowPerPage) {
  return {
    type: "GET_NOTIFICATIONS_POP",
    payload: source.getNotifications(id, type, page, rowPerPage),
  };
}
export function getDataCountFunc(id) {
  console.log(id, "in data count func");
  return function (dispactch) {
    dispactch({
      type: "GET_DATA_COUNT",
      payload: source.getDataCount(id),
    });
  };
}
